import { render, staticRenderFns } from "./TodoListGroupTitle.vue?vue&type=template&id=532fa5d2&scoped=true"
import script from "./TodoListGroupTitle.vue?vue&type=script&lang=ts"
export * from "./TodoListGroupTitle.vue?vue&type=script&lang=ts"
import style0 from "./TodoListGroupTitle.vue?vue&type=style&index=0&id=532fa5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532fa5d2",
  null
  
)

export default component.exports